export default __webpack_public_path__ + "static/media/learose4-480w.e4ba8612.avif";